import MyTransportsRoot from './components/MyTransportsRoot.vue'
import TransportDetailsRoot from './components/transport-details/TransportDetailsRoot.vue'

export default [
  {
    path: 'my-transports',
    component: MyTransportsRoot
  },
  {
    path: 'my-transports/:transportId',
    component: TransportDetailsRoot,
    props: true
  }
]
